import {Button, Modal} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useState} from 'react'
import {CodiDocumentRowSelector, CodiDocumentSelector,} from 'views/Document/EditForms/CodiDocumentSelector'

const AdjPicker = ({
  children,
  onRowChange,
  codi_document,
  current_row_id,
  onDocumentChange,
}) => {
  const t = useTranslate()

  const [current, setCurrent] = useState([,])

  const [isToggle, toggle] = useState(false)

  const view = _.isFunction(children)
    ? children([isToggle, toggle], codi_document)
    : children

  const handleSubmit = () => {
    onRowChange(current)
    toggle(false)
  }

  return (
    <React.Fragment>
      {view}
      <Modal
        footer={null}
        open={isToggle}
        onCancel={() => toggle(false)}
        title={
          <div className="text-center text-color-000 font-semibold uppercase">
            {t('references')}
          </div>
        }>
        {/*<div className="text-sm text-color-300 font-medium uppercase mb-1">*/}
        {/*  {t('document')}*/}
        {/*</div>*/}
        <div className="flex flex-col gap-2">
          <div className="font-medium text-sm text-color-400">
            {t('choose a book')}
          </div>
          <CodiDocumentSelector
            onChange={onDocumentChange}
            current_row_id={current_row_id}
            placeholder={t('codi document')}
          />
          {codi_document && (
            <CodiDocumentRowSelector
              onChange={(item, option) => {
                setCurrent([item, option])
              }}
              placeholder={
                <span className="text-xs italic text-color-400">
                  {t('ex:type-cd')}
                </span>
              }
              codi_document={codi_document}
            />
          )}
          <div className="flex items-center justify-end my-2 gap-2">
            <Button
              className="button-rounded-full no-border"
              onClick={() => toggle(false)}>
              {t('cancel')}
            </Button>
            <Button
              className="button-rounded-full no-border"
              type="primary"
              onClick={handleSubmit}
              disabled={
                current
                  ? _.some(
                      Array.from(current),
                      (value) => !!!value || _.isEmpty(value)
                    )
                  : true
              }>
              {t('choose')}
            </Button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default AdjPicker
